<template>
  <app-page-section
    :subtitle="{ tag: 'h3', text: 'Une expérience de formation exclusive' }"
    :title="{
      tag: 'p',
      text: 'Pollen House, un espace central pour s’inspirer, prendre du recul et networker',
    }"
  >
    <ul
      class="group grid grid-cols-2 gap-2 transition-all duration-500 md:grid-cols-[1fr_1fr_1fr_1fr] md:has-[li:nth-child(1):hover]:grid-cols-[3fr_1fr_1fr_1fr] md:has-[li:nth-child(2):hover]:grid-cols-[1fr_3fr_1fr_1fr] md:has-[li:nth-child(3):hover]:grid-cols-[1fr_1fr_3fr_1fr] md:has-[li:nth-child(4):hover]:grid-cols-[1fr_1fr_1fr_3fr]"
    >
      <li
        v-for="place in places"
        :key="place.cover"
        class="group/item relative overflow-hidden rounded transition duration-500 hover:!opacity-100 group-hover:opacity-30"
      >
        <app-image
          alt=""
          class="aspect-square w-full object-cover md:aspect-auto md:h-[min(70vh,650px)]"
          :src="place.cover"
        />
        <p
          class="absolute bottom-0 hidden w-full translate-y-2 items-center gap-2 overflow-hidden bg-gradient-to-t from-black/70 from-20% px-4 pb-6 pt-8 text-white opacity-0 transition duration-500 group-hover/item:translate-y-0 group-hover/item:opacity-100 md:flex"
        >
          <app-icon icon="ph:map-pin" />
          <span class="whitespace-nowrap" v-html="place.label" />
        </p>
      </li>
    </ul>

    <template v-if="$slots.append" #append>
      <slot name="append" />
    </template>
  </app-page-section>
</template>

<script lang="ts" setup>
const places: { cover: string; label: string }[] = [
  {
    cover:
      "https://res.cloudinary.com/dfdgwwkpd/image/upload/v1712744415/brand/enterprise/session_location_4_gbm75p.jpg",
    label: "<strong>Pollen House</strong>, 3 rue Rossini, Paris",
  },
  {
    cover:
      "https://res.cloudinary.com/dfdgwwkpd/image/upload/v1712744414/brand/enterprise/session_location_2_lixcq3.jpg",
    label: "<strong>Pollen House</strong>, 3 rue Rossini, Paris",
  },
  {
    cover:
      "https://res.cloudinary.com/dfdgwwkpd/image/upload/v1712744414/brand/enterprise/session_location_1_ez0hsf.jpg",
    label: "<strong>Pollen House</strong>, 3 rue Rossini, Paris",
  },
  {
    cover:
      "https://res.cloudinary.com/dfdgwwkpd/image/upload/v1712744415/brand/enterprise/session_location_3_gqd43c.jpg",
    label: "<strong>Pollen House</strong>, 3 rue Rossini, Paris",
  },
];
</script>
